import React from "react";

function TextTable({ response, onChange }) {
  return (
    <div className="form-group mb-3">
      <div className="row">Text Tables are not editable</div>
    </div>
  );
}

export default TextTable;
